import { batch } from '../../modules/lib/batchReducer'
import {
  startCommunication,
  endCommunication
} from '../../modules/communication'
import { isResettingPassword, isSendingIntructions } from './selectors'
import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_RESOURCE,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED,
  SEND_INSTRUCTIONS_RESOURCE,
  SEND_INSTRUCTIONS_REQUEST,
  SEND_INSTRUCTIONS_SUCCESS,
  SEND_INSTRUCTIONS_FAILED
} from './constants'
import client from '../../core/feathers'

export const beginRequest = (type, resource) =>
  batch(type, startCommunication(resource))

export const endRequest = (type, resource, isSuccess = true) =>
  batch(type, endCommunication(resource, isSuccess))

export function createPasswordReset(email) {
  return async function(dispatch, getState) {
    const resource = SEND_INSTRUCTIONS_RESOURCE
    if (isSendingIntructions(getState())) return
    dispatch(beginRequest(SEND_INSTRUCTIONS_REQUEST, resource))
    try {
      const result = await client.service('password-reset').create({ email })
      console.log('Password reset result', result)
      dispatch(
        batch(SEND_INSTRUCTIONS_SUCCESS, endCommunication(resource, true))
      )
      return { result }
    } catch (error) {
      console.error('Error creating password reset', error)
      dispatch(endRequest(SEND_INSTRUCTIONS_FAILED, resource, false))
      return { error }
    }
  }
}

export function updatePassword(resetToken, newPassword) {
  return async function(dispatch, getState) {
    const resource = RESET_PASSWORD_RESOURCE
    if (isResettingPassword(getState())) return
    dispatch(beginRequest(RESET_PASSWORD_REQUEST, resource))
    try {
      const result = await client.service('password-reset').patch(resetToken, {
        password: newPassword
      })
      console.log('updatePassword success', result)
      dispatch(endRequest(RESET_PASSWORD_SUCCESS, resource))
      return { result }
    } catch (error) {
      console.error('Error resetting password', error)
      dispatch(endRequest(RESET_PASSWORD_FAILED, resource, false))
      return { error }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/password-reset/actions.js